// src/config/blockThemes.js
const blockThemes = [
  {
    style: {
      '--theme-color': 'white',
      '--theme-high-contrast-color': 'var(--blue)',
      '--theme-foreground-color': 'var(--charcoal)',
      '--theme-low-contrast-foreground-color': 'var(--lightblue)',
      '--link-foreground-color': 'var(--blue)',
    },
    name: 'default',
    label: 'Default',
  },
  {
    style: {
      '--theme-color': 'var(--lightgrey)',
      '--theme-high-contrast-color': 'var(--charcoal)',
      '--theme-foreground-color': 'var(--charcoal)',
      '--theme-low-contrast-foreground-color': 'var(--medblue)',
      '--link-foreground-color': 'var(--blue)',
    },
    name: 'lightgrey',
    label: 'Light Grey',
  },
  {
    style: {
      '--theme-color': 'var(--medblue)',
      '--theme-high-contrast-color': 'white',
      '--theme-foreground-color': 'white',
      '--theme-low-contrast-foreground-color': 'white',
      '--link-foreground-color': 'white',
    },
    name: 'medblue',
    label: 'Medium Blue',
  },
  {
    style: {
      '--theme-color': 'var(--blue)',
      '--theme-high-contrast-color': 'white',
      '--theme-foreground-color': 'white',
      '--theme-low-contrast-foreground-color': 'white',
      '--link-foreground-color': 'white',
    },
    name: 'darkblue',
    label: 'Dark Blue',
  },
  {
    style: {
      '--theme-color': 'var(--charcoal)',
      '--theme-high-contrast-color': 'white',
      '--theme-foreground-color': 'white',
      '--theme-low-contrast-foreground-color': 'white',
      '--link-foreground-color': 'white',
    },
    name: 'charcoal',
    label: 'Charcoal',
  },
];

export default blockThemes;
